// No async data loading needed for Help page
export const loadData = () => dispatch => {
  return Promise.resolve();
};
